module.exports = __webpack_public_path__ + "static/img/decidoc-01.15aec20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/decidoc-01.png
// module id = 74
// module chunks = 0